// crm namespace — deleting clients from the Clients list (owner only, owner decision
// 2026-10-21): the per-row control and the bulk "Delete selected" with its typed count.
// Counts are written as "label: {n}" so one sentence fits one client or many.
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "clientDelete.bulkAction": "Supprimer la sélection",
    "clientDelete.bulkBody": "Pour chaque client, la fiche CRM, son historique et ses notes sont supprimés. Les reçus et les réservations restent. Un client supprimé qui réserve ou paie de nouveau revient comme nouveau prospect. Pour une demande d'effacement, utilisez plutôt « Effacer les données du client » sur sa fiche.",
    "clientDelete.bulkConfirm": "Supprimer les clients",
    "clientDelete.bulkCount": "Clients à supprimer : {n}",
    "clientDelete.bulkDone": "Clients supprimés : {n}",
    "clientDelete.bulkTitle": "Supprimer les clients sélectionnés ?",
    "clientDelete.colActions": "Actions",
    "clientDelete.rowAction": "Supprimer {name}",
    "clientDelete.typeCount": "Saisissez {n} pour confirmer",
    "errors.deleteCountMismatch": "La sélection ne correspond plus aux clients enregistrés (des clients ont été ajoutés ou supprimés entre-temps). Vérifiez la sélection, ou effacez-la et sélectionnez de nouveau, puis réessayez.",
  },
  en: {
    "clientDelete.bulkAction": "Delete selected",
    "clientDelete.bulkBody": "Each client's CRM record, timeline and notes are removed. Receipts and bookings stay. A deleted client who books or pays again comes back as a new lead. To honour an erasure request, use Erase client data on the client's record instead.",
    "clientDelete.bulkConfirm": "Delete clients",
    "clientDelete.bulkCount": "Clients to delete: {n}",
    "clientDelete.bulkDone": "Clients deleted: {n}",
    "clientDelete.bulkTitle": "Delete the selected clients?",
    "clientDelete.colActions": "Actions",
    "clientDelete.rowAction": "Delete {name}",
    "clientDelete.typeCount": "Type {n} to confirm",
    "errors.deleteCountMismatch": "The selection no longer matches the clients on file (clients were added or deleted in the meantime). Check the selection, or clear it and select again, then retry.",
  },
  es: {
    "clientDelete.bulkAction": "Eliminar la selección",
    "clientDelete.bulkBody": "Para cada cliente se eliminan la ficha del CRM, su historial y sus notas. Los recibos y las reservas se conservan. Un cliente eliminado que vuelve a reservar o pagar regresa como nuevo contacto. Para una solicitud de borrado, usa «Borrar los datos del cliente» en su ficha.",
    "clientDelete.bulkConfirm": "Eliminar clientes",
    "clientDelete.bulkCount": "Clientes a eliminar: {n}",
    "clientDelete.bulkDone": "Clientes eliminados: {n}",
    "clientDelete.bulkTitle": "¿Eliminar los clientes seleccionados?",
    "clientDelete.colActions": "Acciones",
    "clientDelete.rowAction": "Eliminar a {name}",
    "clientDelete.typeCount": "Escribe {n} para confirmar",
    "errors.deleteCountMismatch": "La selección ya no coincide con los clientes registrados (se añadieron o eliminaron clientes mientras tanto). Revisa la selección, o bórrala y vuelve a seleccionar, y reinténtalo.",
  },
};
